import { TabView, TabPanel } from 'primereact/tabview';
import { useState, useEffect } from 'react';
import { TechDetailsForm } from './tech-details';
import { DescriptionForm } from './description';
import { DocumentationForm } from './documentation';

import { IApplicationFormatted } from '../../../types';
import { useIntl } from 'react-intl';

import useAppDetails from './app-details.hook';
import classes from '../../../../pages/main-page/main-page.module.scss';
import { New_footer as SimpleFooter } from '../../../layouts/landing-layout/footer/footer';

import './styles.scss';

type TAppDetailsProps = {
  application: IApplicationFormatted;
  registerApplicationResponse: any;
  submitToPublishResponse: any;
  activateDeactivateApplicationResponse: any;
  isCreated: boolean;
  isPublished: boolean;
  applicationId: string;
  onChangeIsApplicationInEditMode: any;
  isReadyToPublish: boolean;
};

export const AppDetails = ({
  application,
  registerApplicationResponse,
  submitToPublishResponse,
  activateDeactivateApplicationResponse,
  isCreated,
  isPublished,
  applicationId,
  onChangeIsApplicationInEditMode,
  isReadyToPublish
}: TAppDetailsProps): JSX.Element => {
  const { activeTabIndex, setActiveTabIndex } = useAppDetails({
    application,
  });

  const { formatMessage } = useIntl();
  const [errorsList, setErrorList] = useState({});

  useEffect(() => {
    onChangeIsApplicationInEditMode();
  }, [activeTabIndex]);

  const defineTabErrors = (errors: [], tabName: string) => {
    return errors
      ?.map((item: any) => item.source.split('/')[0])
      .find((item: any) => item === tabName);
  };
  const setResponseErrors = (response: any) => {
    const errorsList = response?.errors?.reduce((acc: any, item: any) => {
      const errorfield = item.source.split('/')[1];
      return { ...acc, [errorfield]: item.message };
    }, {});
    setErrorList(errorsList);
  };

  useEffect(() => {
    if (registerApplicationResponse) {
      setResponseErrors(registerApplicationResponse);
    }
    if (submitToPublishResponse) {
      setResponseErrors(submitToPublishResponse);
    }
    if (activateDeactivateApplicationResponse) {
      setResponseErrors(activateDeactivateApplicationResponse);
    }

    const isTechDetailsErrors =
      defineTabErrors(registerApplicationResponse?.errors, 'tech_details') ||
      defineTabErrors(submitToPublishResponse?.errors, 'tech_details') ||
      defineTabErrors(
        activateDeactivateApplicationResponse?.errors,
        'tech_details'
      );
    const isDescriptionErrors =
      defineTabErrors(submitToPublishResponse?.errors, 'description') ||
      defineTabErrors(
        activateDeactivateApplicationResponse?.errors,
        'description'
      );

    if (isTechDetailsErrors) {
      setActiveTabIndex(0);
    }
    if (isDescriptionErrors) {
      setActiveTabIndex(1);
    }
  }, [
    registerApplicationResponse,
    submitToPublishResponse,
    activateDeactivateApplicationResponse,
  ]);

  return (
    <div>
      <section className={'dev-portal__dashboard__app-page__details-section'}>
        <div className={'tab-view-container table-view'}>
          <TabView
            renderActiveOnly={false}
            activeIndex={activeTabIndex}
            onTabChange={(e) => setActiveTabIndex(e.index)}
          >
            <TabPanel
              header={formatMessage({
                id: 'developer_portal_app_details_tab_tech_details',
              })}
            >
              <TechDetailsForm
                applicationId={applicationId}
                isPublished={isPublished}
                isReadyToPublish={isReadyToPublish}
                isCreated={isCreated}
                onChangeIsApplicationInEditMode={onChangeIsApplicationInEditMode}
                apiResponseErrors={errorsList}
              />
            </TabPanel>
            <TabPanel
              header={formatMessage({
                id: 'developer_portal_app_details_tab_description',
              })}
            >
              <DescriptionForm
                onChangeIsApplicationInEditMode={onChangeIsApplicationInEditMode}
                currentApplication={application}
                apiResponseErrors={errorsList}
                isPublished={isPublished}
                isReadyToPublish={isReadyToPublish}
              />
            </TabPanel>
            <TabPanel
              header={formatMessage({
                id: 'developer_portal_app_details_tab_documentation',
              })}
            >
              <DocumentationForm
                apiResponseErrors={errorsList}
                onChangeIsApplicationInEditMode={onChangeIsApplicationInEditMode}
              />
            </TabPanel>

            {/* <TabPanel
              header={formatMessage({
                id: 'developer_portal_app_details_tab_transaction_log',
              })}
            >
              <TransactionLog apiResponseErrors={errorsList} />
            </TabPanel> */}
          </TabView>
        </div>
      </section>
      <div className={classes.registrationFooter}>
        <SimpleFooter/>
      </div>
    </div>
  );
};
